export interface PayInstallment {
    llpId: string;
    amount: number;
}
